
function initLayer1Menu(indx) {

    // -------------------------------------------------------------
    //   Frame1 Navigation
    // -------------------------------------------------------------

    var $frame1 = $('#centered1');

    if ($frame1 != null) {

        var $wrap1 = $frame1.parent();

        //$frame1.destroy();

        // Call Sly on frame
        let sly1 = $frame1.sly({
            horizontal: 1,
            itemNav: 'centered',
            smart: 1,
            activateOn: 'click',
            mouseDragging: 1,
            touchDragging: 1,
            releaseSwing: 1,
            startAt: indx,
            scrollBar: $wrap1.find('.scrollbar'),
            scrollBy: 1,
            speed: 300,
            elasticBounds: 1,
            easing: 'easeOutExpo',
            dragHandle: 1,
            dynamicHandle: 1,
            clickBar: 1,

            // Buttons
            prev: $wrap1.find('.prev'),
            next: $wrap1.find('.next'),
        });


    }
}

var mysly2 = null;
function initLayer2Menu(indx) {

    // -------------------------------------------------------------
    //   Frame2 Navigation
    // -------------------------------------------------------------

    var $frame2 = $("#centered2");

    if ($frame2 != null) {


        var $wrap2 = $frame2.parent();

        var options = {
            horizontal: 1,
            itemNav: 'centered',
            smart: 1,
            activateOn: 'click',
            mouseDragging: 1,
            touchDragging: 1,
            releaseSwing: 1,
            startAt: indx,
            scrollBar: $wrap2.find('.scrollbar'),
            scrollBy: 1,
            speed: 300,
            elasticBounds: 1,
            easing: 'easeOutExpo',
            dragHandle: 1,
            dynamicHandle: 1,
            clickBar: 1,

            // Buttons
            prev: $wrap2.find('.prev'),
            next: $wrap2.find('.next'),
        }

        if (mysly2 != null) {
            mysly2.destroy();
            mysly2 = null;
        }

        //console.log("id=" + id);
        mysly2 = new Sly("#centered2", options).init();



    }


}

var mysly3 = null;
function initLayer3Menu(indx) {

    // -------------------------------------------------------------
    //   Frame3 Navigation
    // -------------------------------------------------------------

    var $frame3 = $("#centered3");

    if ($frame3 != null) {


        var $wrap3 = $frame3.parent();

        var options = {
            horizontal: 1,
            itemNav: 'centered',
            smart: 1,
            activateOn: 'click',
            mouseDragging: 1,
            touchDragging: 1,
            releaseSwing: 1,
            startAt: indx,
            scrollBar: $wrap3.find('.scrollbar'),
            scrollBy: 1,
            speed: 300,
            elasticBounds: 1,
            easing: 'easeOutExpo',
            dragHandle: 1,
            dynamicHandle: 1,
            clickBar: 1,

            // Buttons
            prev: $wrap3.find('.prev'),
            next: $wrap3.find('.next'),
        }

        if (mysly3 != null) {
            mysly3.destroy();
            mysly3 = null;
        }

        //console.log("id=" + id);
        mysly3 = new Sly("#centered3", options).init();



    }


}